import { render, staticRenderFns } from "./ScrollSpy.vue?vue&type=template&id=11ca4ff1&lang=pug&"
import script from "./ScrollSpy.vue?vue&type=script&lang=ts&"
export * from "./ScrollSpy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports